import React, { useState } from 'react';
import { AddAppointment, Container1, Container2, BoxContainer, ReportText, BoxInner1, InnerAppointments, Text, Texts, Text2, DataContainer, StatusData, LineContainer, MenuContainer, InnerBox, PagingContainer } from './Styles';
import { ReactComponent as Add } from '../../../../../../src/assets/images/add-square.svg';
import InputSelect from 'src/components/shared/Form/Select';
import { ReactComponent as MenuIcon } from '../../../../../assets/images/more.svg';
import { palette } from 'src/config/theme';
import Paging from 'src/components/App/Paging';
import { Box, alpha, Menu, Typography, MenuItem } from '@mui/material';
import NoDataFound from '../../NoDataFound/NoDataFound';
import DialogBox from 'src/components/shared/Dialog/DialogBox';
import ReportTabForm from '../Forms/ReportTabForm';
import { ReactComponent as View } from '../../../../../assets/images/eye.svg';
import { ReactComponent as Download } from '../../../../../assets/images/document-download.svg';
import theme from 'src/config/theme';


const ReportCard = ({ report = [], page, perPage, setPage, totalCount, fetchReports, handleViewReport, handleDownloadReport }) => {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const data = report.map((reportData) => ({
        reportId: reportData.id,
        reports: reportData.typesOfReports,
        reportName: reportData.filename,
        contentType: reportData.contentType,
        // addedDate: '15th Oct, 10:00am',
    }))
    const handleMenuOpen = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(item);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };

    const actions = [
        { label: "View", icon: <View />, onClick: (row) => handleViewReport(row.reportId, row.contentType) },
        { label: "Download", icon: <Download />, onClick: (row) => handleDownloadReport(row.reportId, row.contentType, row.reportName) },
    ];
    return (
        <>
            <Container1>
                <AddAppointment
                    startIcon={<Add width="18px" height="18px" />}
                    onClick={handleOpen}
                >Add Report</AddAppointment>


            </Container1>
            <Container2>
                <InnerAppointments>
                    <InnerBox isEmpty={data.length === 0}>

                        {data.length === 0 ? (
                            <NoDataFound
                                title="No Report Found!"
                                buttonText="Add Report"
                                buttonIcon={Add}
                                onClick={handleOpen}
                            />

                        ) : (
                            <>
                                {data.map((item) => (
                                    <BoxContainer key={item.reportId}>
                                        <BoxInner1>
                                            <DataContainer>
                                                <ReportText
                                                >{item.reportName}</ReportText>
                                                <Texts>{item.reports}</Texts>
                                            </DataContainer>

                                        </BoxInner1>
                                        <LineContainer />
                                        <BoxInner1 sx={{ justifyContent: 'flex-end' }}>
                                            {/* <DataContainer>
                                    <Text>15 Nov, 2024. 10:00am</Text>
                                    <Texts>Date & Time</Texts>
                                </DataContainer> */}
                                            <MenuContainer
                                                onClick={(event) => handleMenuOpen(event, item)}
                                                isActive={selectedRow === item}
                                            >
                                                <MenuIcon />
                                            </MenuContainer>
                                            <Menu
                                                anchorEl={anchorEl}
                                                open={Boolean(anchorEl)}
                                                onClose={handleMenuClose}
                                                sx={{
                                                    "& .MuiPaper-root": {
                                                        width: "176px",
                                                        borderRadius: "12px",
                                                        padding: "4px 18px",
                                                        backgroundColor: "red",
                                                        border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
                                                        backgroundColor: theme.palette.gery.white,
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        gap: '14px',
                                                    }
                                                }}
                                            >
                                                {actions.map((action, index) => (
                                                    <MenuItem key={index} onClick={() => {
                                                        action.onClick(selectedRow);
                                                        handleMenuClose();
                                                    }}>
                                                        <Box display="flex" alignItems="center" gap={1}>
                                                            {action.icon} <Typography>{action.label}</Typography>
                                                        </Box>
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </BoxInner1>
                                    </BoxContainer>
                                ))}
                            </>
                        )}

                    </InnerBox>
                    <PagingContainer>
                        <Paging
                            page={page}
                            perPage={perPage}
                            count={totalCount || 0}
                            onChange={(newPage) => setPage(newPage)}
                        />
                    </PagingContainer>
                </InnerAppointments>
                <DialogBox open={open} onClose={handleClose} >
                    <ReportTabForm onClose={handleClose} fetchReports={fetchReports} />
                </DialogBox>
            </Container2>
        </>
    )
}

export default ReportCard
